import { useTranslation } from 'react-i18next';
import React, { useContext, useState ,useEffect} from "react";
import { KeycloakContext } from "../context/KeycloakContext";
import { Checkbox } from "primereact/checkbox";
import { approveDataPrivacy, privacyStatus } from "../helpers/ApiRequests";
import { Button } from 'primereact/button';

const PrivacyPolicy = ({ onCheckPrivacy }) => {
    const { kc } = useContext(KeycloakContext);
    const { t } = useTranslation();
    const [checked, setChecked] = useState(false);  // Start unchecked, requiring user action

    const getPrivacyStatus = async () => {
        const approved = await privacyStatus(kc);
        setChecked(approved); // 'approved' is already a boolean
    };

    useEffect(() => {
        if (kc) {
            getPrivacyStatus();
        }
    }, [kc]); // Ensure it runs only when 'kc' is defined and potentially changes


    const setPrivacyStatus = async () => {
        if (checked) {
            const resp = await approveDataPrivacy(kc, true);
            console.log('setPrivacyStatus', resp);
            if (resp && resp.message === "Data privacy details set successfully") {
                onCheckPrivacy(false);  // This will close the modal
            }
        } else {
            console.log('Attempt to save without approval');
            // Optionally provide feedback that the checkbox must be checked
        }
    };

    return (
        <div className='mimetika-policy'>
            <h1 className="text-2xl sm:text-3xl uppercase py-4">{t('privacy_policy.title')}</h1>
            <div className="border-white border-y-3 py-2 ">
                <div className="mimetika-policy-text text-xs overflow-auto px-2 sm:px-4 max-h-98 text-left whitespace-pre-line">
                    {t('privacy_policy.content')}
                </div>
            </div>
            <div className="pt-4 px-2 sm:px-4 align-items-center grid grid-cols-1 md:grid-cols-2 m-0">
                <div className="text-left py-2">
                    <label className="label-checkbox text-xs">
                        <Checkbox onChange={(e) => setChecked(e.checked)} checked={checked} className="mimetika-checkbox" />
                        <span className="ml-3">{t('privacy_policy.aceptance')}</span>
                    </label>
                </div>
                <div className="text-center sm:text-right">
                    <Button className="btn-primary" disabled={!checked} onClick={setPrivacyStatus}>{t('Save')}</Button>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
